import { createReducer, on } from '@ngrx/store'
import { HeaderActions } from './action-types'
import cloneDeep from 'lodash/cloneDeep'
import { PerfectScrollbarActions } from '../../../../shared/ui/perfect-scrollbar/state/actions-type'
import { StoreKeysEnum } from '../../../../store/store-keys'

export const initState: IHeaderState = {
    filterCriteria: {
        limit: 20,
        offset: 0,
        lastYear: true,
        alreadyRead: false
    },
    itemCollection: null
}

export const headerReducer = createReducer(
    {},
    on(HeaderActions.initStore, (state, props) => {
        const initialState = cloneDeep(initState)
        initialState.filterCriteria.alreadyRead = props.alreadyRead
        return !state[props.key] ? {...state, [props.key]: initialState} : {...state, [props.key]: { ...state[props.key], ...initialState }}
    }),
    on(HeaderActions.reset, (state, props) => {
        const [, afterColon] = props.key.split(':')
        return { ...state, [afterColon]: initState }
    }),
    on(HeaderActions.setFilterCriteria, (state, props) => {
        const [, afterColon] = props.key.split(':')
        return { ...state, [afterColon]: { ...state[afterColon], filterCriteria: props.criteria }}
    }),
    on(HeaderActions.setItemCollection, (state, props) => {
        const [, afterColon] = props.key.split(':')
        return { ...state, [afterColon]: { ...state[afterColon], itemCollection: props.itemCollection }}
    }),
    on(HeaderActions.updateFilterCriteria, (state, props) => {
        return { ...state, [props.key]: { ...state[props.key], filterCriteria: { ...state[props.key].filterCriteria, ...props.filterCriteriaFragment }}}
    }),
    on(PerfectScrollbarActions.updateOriginFilterCriteria, (state, props): Record<string, IHeaderState> => {
        if (!props.key) {
            return state
        }
        const [beforeColon, afterColon] = props.key.split(':')
        return beforeColon === StoreKeysEnum.HeaderComponent ? {
            ...state,
            [afterColon]: { ...state[afterColon], filterCriteria: { ...state[afterColon].filterCriteria, ...props.fragment } },
        } : state
    }),
)

export interface IHeaderState {
    filterCriteria: IHeaderFilterCriteria;
    itemCollection: any[];
}

export interface IHeaderFilterCriteria {
    limit: number;
    offset: number;
    lastYear: boolean;
    alreadyRead: boolean;
}